import { create } from "zustand";
import { persist } from "zustand/middleware";

export type DictationMethod = "text" | "audio";

type SettingsState = {
  /** 書き起こしモードの方式 */
  dictationMethod: DictationMethod;
  setDictationMethod: (method: DictationMethod) => void;
};

/** アプリ全体の設定（端末のローカルストレージに保存） */
export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      dictationMethod: "text",
      setDictationMethod: (dictationMethod) => set({ dictationMethod }),
    }),
    { name: "lexivision-settings" },
  ),
);
